import { render } from "./AjouterOrganisation.vue?vue&type=template&id=e605e1e8&scoped=true&ts=true"
import script from "./AjouterOrganisation.vue?vue&type=script&lang=ts"
export * from "./AjouterOrganisation.vue?vue&type=script&lang=ts"

import "./AjouterOrganisation.vue?vue&type=style&index=0&id=e605e1e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e605e1e8"]])

export default __exports__